import LogoutIcon from "view/images/LogoutIcon";
import React, {FC} from "react";
import {IconButton, Tooltip} from "@material-ui/core";
import {useTranslate} from "@tolgee/react";
import {useLogout} from "hooks";
import useStyles from "./styles";

type UserActionsMenuProps = {
  iconColor?: string;
};

const UserActionsMenu: FC<UserActionsMenuProps> = ({iconColor}) => {
  const classes = useStyles();
  const {t} = useTranslate();

  const logOut = useLogout();

  return (
    <Tooltip title={t("common.action.log_out")} placement="bottom">
      <IconButton id="logout" className={classes.logoutButton} onClick={logOut}>
        <LogoutIcon style={{fill: iconColor}} />
      </IconButton>
    </Tooltip>
  );
};

export default UserActionsMenu;
